import 'lazysizes';
import Vue from 'vue';
import VueI18n from 'vue-i18n'
import Toasted from 'vue-toasted';
Vue.use(Toasted, {
	containerClass: 'notification',
	className: 'notification__item',
	position: 'top-right',
	duration: 4000,
	action: [
		{
			text: 'Close',
			onClick: (e, toastObject) => {
				toastObject.goAway(0);
			}
		},
	]
});
// const env = await import.meta.env;
// Vue.config.productionTip = env.MODE !== 'production';
// Vue.config.devtools      = env.MODE !== 'production';
Vue.component('shared-loader', () => ({
	component: import('./SharedLoader.vue')
}));
Vue.component('shared-social-sharing', () => ({
	component: import('./SharedSocialSharing.vue')
}));
Vue.component('shared-weather', () => ({
	component: import('./SharedWeather.vue')
}));
Vue.component('header-navigation', () => ({
	component: import('./HeaderNavigation.vue')
}));
Vue.component('auth-modal', () => ({
	component: import('./auth/AuthModal.vue')
}));
Vue.component('side-bar', () => ({
	component: import('./SideBar.vue')
}));
Vue.component('back-to-top', () => ({
	component: import('./BackToTop.vue')
}));
Vue.use(VueI18n);

// добавить в messages файл перевода нужного модуля из php
const locale =  window.Laravel.locale || 'ru';
// Import your localization messages
import en from '../../lang/php_en.json';
import ru from '../../lang/php_ru.json';
import ka from '../../lang/php_ka.json';
// Convert your messages to a format that vue-i18n can understand
const messages = {
	en,	ru, ka
};
const lang = new VueI18n({
	locale: locale, // set locale
	fallbackLocale: 'ru', // set fallback locale
	messages // set locale messages
});

Vue.filter('trans', (...args) => {
	return lang.t(...args);
});

Vue.filter('moneyFormatter', function (value) {
	value = parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ");
	let splited = value.split('.');
	if(splited[1] === '00'){
		value = splited[0];
	}
	return value;
});

export { Vue, lang }
